export function sortProperties<T extends { name?: string | null }>(arr: readonly T[]): T[] {
  return [...arr].sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));
}
